import { useTranslation } from "react-i18next";
import { ITable } from "../../../interfaces";
import { useHistory, useLocation } from "react-router-dom";
import React from "react";
import { Box, Button, Grid, makeStyles } from "@material-ui/core";
import EnhanceLink from "../../Common/EnhanceLink";
import { convertUTCDateToLocalDate } from "../../../utils/date";
import { prettyNum } from "../../../utils/prettyNum";
import CryptoJS from "crypto-js";
import AvTimerIcon from "@material-ui/icons/AvTimer";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import { Status } from "../../Users/List/styles";

const useStyles = makeStyles(() => ({
  balance: {
    cursor: "pointer",
    color: "white",
    backgroundColor: "#919191",
    padding: "3px",
    fontWeight: "bold",
    width: "max-content",
  },
  img: {
    width: "auto",
    height: "30vh",
  },
}));

interface MainTabInfoProps {
    table: ITable;
    showPayment: () => void;
    isNotReferral: boolean;
}

const MainTabInfo: React.FC<MainTabInfoProps> = ({ table, showPayment, isNotReferral }) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const history = useHistory();
    const location = useLocation<{ prevPaths?: string[] }>();
    const currency_id = table?.hall?.currency_id;

    const navigateToHistory = (param: string) => {
        history.push({
            pathname: location.pathname,
            search: `${location.search}&${param}=1`,
            state: { prevPaths: location.state?.prevPaths || [] },
        });
    };

    return (
        <React.Fragment>
            <Grid item xs={12} md={6}>
                <Box><b>{t("ru.tables.fields.name")}:</b> {table.name}</Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box>
                    <b>{t("ru.tables.fields.hall")}:</b>{" "}
                    <EnhanceLink pathname={`/halls`} search={`?hall_id=${table.hall.id}`}>
                        {table.hall?.name}
                    </EnhanceLink>
                </Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box><b>{t("ru.tables.fields.login")}:</b> {table.login}</Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box><b>{t("ru.tables.fields.password")}:</b> {table.password}</Box>
            </Grid>
            <Grid item xs={12} md={12}>
                <Box><b>{t("ru.tables.fields.token")}:</b> {CryptoJS.MD5(`${table.login}:${table.password}`).toString()}</Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box onClick={() => isNotReferral && showPayment()}>
                    <b>{t("ru.tables.fields.balance")}:</b>{" "}
                    <span className={classes.balance}>
                        {!!currency_id && prettyNum(table.balance[currency_id])}({currency_id})
                    </span>
                </Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box><b>{t("ru.tables.fields.denomination")}:</b> {table.denomination / 100}</Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box><b>{t("ru.tables.fields.phone")}:</b> {table.phone ?? "не указан"}</Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box><b>{t("ru.tables.fields.email")}:</b> {table.email ?? "не указан"}</Box>
            </Grid>

            <Grid item xs={12} md={6}>
                <Box display="flex" justifyContent="center" alignItems="flex-start" flexDirection="column">
                    <b>{t("ru.tables.fields.created_at")}:</b>
                    <Box style={{ width: "100%" }} display="flex" justifyContent="flex-start" alignItems="center" flexDirection="row">
                        <span style={{ margin: "3px" }}>{convertUTCDateToLocalDate(table.created_at)}</span>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box display="flex" justifyContent="center" alignItems="flex-start" flexDirection="column">
                    <b>{t("ru.tables.fields.connection_time")}:</b>
                    <Box style={{ width: "100%" }} display="flex" justifyContent="flex-start" alignItems="center" flexDirection="row">
                        <span style={{ margin: "3px" }}>{convertUTCDateToLocalDate(table.connection_time)}</span>
                    </Box>
                </Box>
            </Grid>

            <Grid item xs={12} md={6}>
                <Box display="flex" justifyContent="center">
                    <Button color="default" variant="contained" onClick={() => navigateToHistory("sessions_page")} style={{ margin: "10px" }}>
                        {t("ru.common.history_sessions_btn")} <AvTimerIcon style={{ margin: "0 10px" }} />
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Box display="flex" justifyContent="center">
                    <Button color="default" variant="contained" onClick={() => navigateToHistory("operations_page")} style={{ margin: "10px" }}>
                        {t("ru.common.history_operations_btn")} <MenuOpenIcon style={{ margin: "0 10px" }} />
                    </Button>
                </Box>
            </Grid>

            <Grid item xs={12} md={6}>
                <Box display="flex" justifyContent="space-between" flexDirection="row">
                    <b>{t("ru.tables.fields.status")}:</b>
                    <Box display="flex">
                        <Status active={!!table.status}>
                            {!!table.status ? t("ru.common.status.active") : t("ru.common.status.inactive")}
                        </Status>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box>
                    <b>{t("ru.tables.fields.referral")}:</b>{" "}
                    {table.referral_id ? (
                        <EnhanceLink pathname={`/tables`} search={`?table_id=${table.referral_id}`}>
                            #{table.referral_id}
                        </EnhanceLink>
                    ) : (
                        "нет"
                    )}
                </Box>
            </Grid>

            {!!table.phone && (
                <Grid item xs={12} md={12}>
                    <Box display="flex" justifyContent="flex-start" gridGap="1em">
                        <b>{t("ru.tables.fields.phone")}:</b>
                        <Box display="flex" gridGap="1em">
                            <b>{table.phone}</b> ({table.phone_state ? "" : "не "}подтверждён)
                        </Box>
                    </Box>
                </Grid>
            )}
            {!!table.email && (
                <Grid item xs={12} md={12}>
                    <Box display="flex" justifyContent="flex-start" gridGap="1em">
                        <b>{t("ru.tables.fields.email")}:</b>
                        <Box display="flex" gridGap="1em">
                            <b>{table.email}</b> ({table.email_state ? "" : "не "}подтверждён)
                        </Box>
                    </Box>
                </Grid>
            )}

            {!!table.currentGame && (
                <Grid item xs={12} md={12}>
                    <Box><b>{t("ru.tables.fields.current_game")}:</b> {table.currentGame.name}</Box>
                    <Box display="flex" justifyContent="center">
                        <img className={classes.img} src={table.currentGame.logo} alt="" />
                    </Box>
                </Grid>
            )}
        </React.Fragment>
    );
};

export default MainTabInfo;